import { Folder, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeFolder(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Folder>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/api/folders/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeFolder };
